module.exports = __webpack_public_path__ + "img/footer.aa0f35ea.png";